var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResetGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2367_8879",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.689209,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2367_8879)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0419 17.1476C8.2395 17.1476 6.70561 16.5205 5.4402 15.2662C4.17464 14.0119 3.54186 12.4862 3.54186 10.6893V10.0387L2.0002 11.5803L1.12207 10.7022L4.16686 7.65721L7.21165 10.7022L6.33353 11.5803L4.79186 10.0387V10.6893C4.79186 12.1369 5.30145 13.3669 6.32061 14.3793C7.33992 15.3915 8.58033 15.8976 10.0419 15.8976C10.387 15.8976 10.7318 15.86 11.0762 15.7847C11.4208 15.7093 11.7571 15.5963 12.0852 15.4457L13.0227 16.3832C12.5537 16.6353 12.0694 16.8257 11.57 16.9545C11.0704 17.0832 10.561 17.1476 10.0419 17.1476ZM15.8335 13.7214L12.7887 10.6764L13.6669 9.79825L15.2085 11.3399V10.6893C15.2085 9.24165 14.6989 8.01165 13.6798 6.99929C12.6605 5.98707 11.4201 5.48096 9.95853 5.48096C9.61339 5.48096 9.2686 5.5186 8.92415 5.59387C8.57957 5.66929 8.24325 5.78228 7.9152 5.93283L6.9777 4.99533C7.44672 4.74325 7.93096 4.55283 8.4304 4.42408C8.92999 4.29533 9.43936 4.23096 9.95853 4.23096C11.7609 4.23096 13.2948 4.85811 14.5602 6.11242C15.8258 7.36672 16.4585 8.89235 16.4585 10.6893V11.3399L18.0002 9.79825L18.8783 10.6764L15.8335 13.7214Z",
    fill: "#409958"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetGreen);
export default __webpack_public_path__ + "static/media/reset-green.ff5d2afc641bb44b45cf5bc20ad173d0.svg";
export { ForwardRef as ReactComponent };